import { useEffect, useState } from "react";

import { RequestApi, RouteApi, StatusMsg } from "utils";

import { AppLog } from "services";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/store";
import { Button } from "components/ui/button";
import { Label } from "components/ui/label";
import TextInput from "components/app/function/TextInput";
import { Loader } from "lucide-react";
import SwitchYesNoWithLabel from "components/app/function/SwitchYesNoWithLabel";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";

export default function TimeSheetSetting({ setAttendanceSetting, attendanceSetting, setOpenPopoverSetting }: any) {
  const location = useLocation();
  const { token } = useAppSelector((state) => state.auth);

  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string) => {
    setAttendanceSetting((prev: any) => ({ ...prev, [key]: e.target.value }));
  };
  const [loadingSubmitAttendanceSetting, setLoadingSubmitAttendanceSetting] = useState<boolean>(false);
  const submitShopAttendanceSetting = async () => {
    setLoadingSubmitAttendanceSetting(true);
    try {
      const url = `${RouteApi.submitShopAttendanceSetting}token=${token}`;
      const data = {
        shop_id: shopId,
        setting: attendanceSetting,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setOpenPopoverSetting(null);
        setLoadingSubmitAttendanceSetting(false);
        setSetting(false);
      }
    } catch (error) {
      setSetting(false);

      setLoadingSubmitAttendanceSetting(false);
      AppLog.show({
        message: `[submitShopAttendanceSetting]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [, setSetting] = useState<boolean>(false);
  console.log(attendanceSetting, "attendanceSetting");

  return (
    <>
      <div className="grid gap-4">
        <div className="space-y-2">
          <h4 className="font-medium leading-none">Setting</h4>
          <p className="text-sm text-muted-foreground">Attendance performance setting.</p>
        </div>
        <div className="grid gap-2">
          <div className="grid grid-cols-3 gap-2 justify-between items-center">
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="late_exception">
                Exception (Late)
              </Label>
              <TextInput className="col-span-2 " value={attendanceSetting.late_exception} onChange={(e) => handleChange(e, "late_exception")} />
            </div>
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="early_exception">
                Exception (Early)
              </Label>
              <TextInput className="col-span-2 " value={attendanceSetting.early_exception} onChange={(e) => handleChange(e, "early_exception")} />
            </div>
          </div>
          <div className="">
            <h5 className="text-[15px] font-bold my-2">Entitlement</h5>
            <div className="grid grid-cols-3  gap-2 justify-between items-center">
              <div className="  space-y-2">
                <Label className=" text-nowrap" htmlFor="annual_leave">
                  Annual Leave
                </Label>
                <TextInput
                  className="col-span-2 "
                  value={attendanceSetting.annual_leave > 0 ? attendanceSetting.annual_leave : ""}
                  onChange={(e) => handleChange(e, "annual_leave")}
                />
              </div>
              <div className=" space-y-2">
                <Label className=" text-nowrap" htmlFor="sick_leave">
                  Sick Leave
                </Label>
                <TextInput className="col-span-2 " value={attendanceSetting.sick_leave > 0 ? attendanceSetting.sick_leave : ""} onChange={(e) => handleChange(e, "sick_leave")} />
              </div>
            </div>
          </div>
          {/* -------- */}
          <div>
            <h5 className="text-[15px] font-bold my-2">Maximum Request No. of Day</h5>

            <div className="grid grid-cols-3  gap-2 justify-between items-center">
              <div className=" space-y-2">
                <Label className=" text-nowrap" htmlFor="max_block_leave">
                  Block Leave
                </Label>
                <TextInput
                  className="col-span-2 "
                  value={attendanceSetting.max_block_leave > 0 ? attendanceSetting.max_block_leave : ""}
                  onChange={(e) => handleChange(e, "max_block_leave")}
                />
              </div>
              <div className="  space-y-2">
                <Label className=" text-nowrap" htmlFor="max_compassionate_leave">
                  Compassionate Leave
                </Label>
                <TextInput
                  className="col-span-2 "
                  value={attendanceSetting.max_compassionate_leave > 0 ? attendanceSetting.max_compassionate_leave : ""}
                  onChange={(e) => handleChange(e, "max_compassionate_leave")}
                />
              </div>
              <div className=" space-y-2">
                <Label className=" text-nowrap" htmlFor="max_change_day_off_leave">
                  Change Day-Off Leave
                </Label>
                <TextInput
                  className="col-span-2 "
                  value={attendanceSetting.max_change_day_off_leave > 0 ? attendanceSetting.max_change_day_off_leave : ""}
                  onChange={(e) => handleChange(e, "max_change_day_off_leave")}
                />
              </div>
            </div>
          </div>
          {/* -------- */}

          <div className="grid grid-cols-3  gap-2 justify-between items-center">
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="max_marriage_leave">
                Marriage Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_marriage_leave > 0 ? attendanceSetting.max_marriage_leave : ""}
                onChange={(e) => handleChange(e, "max_marriage_leave")}
              />
            </div>
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_maternity_leave">
                Maternity Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_maternity_leave > 0 ? attendanceSetting.max_maternity_leave : ""}
                onChange={(e) => handleChange(e, "max_maternity_leave")}
              />
            </div>
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="max_paternity_leave">
                Paternity Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_paternity_leave > 0 ? attendanceSetting.max_paternity_leave : ""}
                onChange={(e) => handleChange(e, "max_paternity_leave")}
              />
            </div>
          </div>
          {/* -------- */}

          <div className="grid grid-cols-3  gap-2 justify-between items-center">
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_special_leave">
                Special Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_special_leave > 0 ? attendanceSetting.max_special_leave : ""}
                onChange={(e) => handleChange(e, "max_special_leave")}
              />
            </div>
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="max_suspend_leave">
                Suspend Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_suspend_leave > 0 ? attendanceSetting.max_suspend_leave : ""}
                onChange={(e) => handleChange(e, "max_suspend_leave")}
              />
            </div>
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_special_leave">
                Special Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_special_leave > 0 ? attendanceSetting.max_special_leave : ""}
                onChange={(e) => handleChange(e, "max_special_leave")}
              />
            </div>
          </div>

          <div className="grid grid-cols-3  gap-2 justify-between items-center">
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="max_annual_leave">
                Annual Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_annual_leave > 0 ? attendanceSetting.max_annual_leave : ""}
                onChange={(e) => handleChange(e, "max_annual_leave")}
              />
            </div>
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_sick_leave">
                Sick Leave
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.max_sick_leave > 0 ? attendanceSetting.max_sick_leave : ""}
                onChange={(e) => handleChange(e, "max_sick_leave")}
              />
            </div>
          </div>

          <h5 className="text-[15px] font-bold my-2">Notify Time In/Out Report To Telegram</h5>
          <div className="grid grid-cols-3  gap-2 justify-between items-center mb-[80px]">
            <div className="  space-y-2">
              <Label className=" text-nowrap" htmlFor="max_sick_leave">
                Telegram Alert
              </Label>
              <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                <SwitchYesNoWithLabel
                  label="Alart Telegram"
                  value={attendanceSetting.alart_telegram}
                  onChange={(e: any) => {
                    console.log(e);
                    // handleChange(e, "alart_telegram");
                    setAttendanceSetting((prev: any) => ({ ...prev, ["alart_telegram"]: e }));
                  }}
                  id={""}
                />
              </div>
            </div>
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_sick_leave">
                Telegram Account ID
              </Label>
              <TextInput
                className="col-span-2 "
                value={attendanceSetting.alert_telegram_id > 0 ? attendanceSetting.alert_telegram_id : ""}
                onChange={(e) => handleChange(e, "alert_telegram_id")}
              />
            </div>
            <div className=" space-y-2">
              <Label className=" text-nowrap" htmlFor="max_sick_leave">
                Language
              </Label>
              <Select
                value={attendanceSetting.alert_telegram_lang}
                onValueChange={
                  (e: any) => {
                    setAttendanceSetting((prev: any) => ({ ...prev, ["alert_telegram_lang"]: e }));
                    console.log(e, "eeee");
                  }

                  // handleChange(e, "alert_telegram_lang")
                }
              >
                <SelectTrigger className="">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {["English", "Khmer"]?.map((items: any, index: number) => (
                      <SelectItem key={index} value={items}>
                        {items}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="flex justify-end items-center gap-4 fixed bottom-3 py-5 right-2 bg-white dark:bg-[#020817] w-[98%]">
            <Button
              className="px-5 dark:text-white me-5"
              onClick={() => {
                submitShopAttendanceSetting();
              }}
            >
              {loadingSubmitAttendanceSetting ? <Loader className="animate-spin" /> : "Save"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
